import { ColorsType } from '@/style/theme/colors';
import tailwindConfig from 'tailwind.config';
import resolveConfig from 'tailwindcss/resolveConfig';
import { DefaultColors } from 'tailwindcss/types/generated/colors';

const tw = resolveConfig(tailwindConfig);
const { theme } = tw as unknown as {
	theme: (typeof tw)['theme'] & { colors: DefaultColors & ColorsType };
};

const notificationUnread =
	'[all:unset] hover:bg-transparent cursor-pointer transition-all [&_svg]:hover:opacity-100 [&_svg]:opacity-70';
const dropdownContent = 'bg-dark-600 shadow-[0_5px_20px_0] shadow-dark-950/30';
const actionButton =
	'mt-[15px] text-[12px] p-[1px_16px] min-h-[24px] rounded-[2px] active:text-dark-950/50 text-dark-950';

export const appearance = {
	preference: {
		enabled: false,
	},
	variables: {
		colorNeutral: 'white',
		neutralForeground: 'white',
		colorBackground: theme.colors.dark[800],
		colorForeground: 'white',
		colorPrimary: theme.colors.primary[500],
		colorSecondary: theme.colors.secondary[500],
		colorSecondaryForeground: 'white',
		counterForeground: theme.colors.primary[500],
		counterColor: theme.colors.dark[950],
		borderRadius: '4px',
	},
	elements: {
		inboxContent: '[&>div:last-child]:hidden',
		popoverTrigger: 'hover:bg-inherit [all:unset]',
		dropdownTrigger: '!bg-transparent',
		inboxHeader: 'p-[20px_24px_20px]',
		notificationListContainer: 'border-t-[1px] border-dark-600',
		popoverContent:
			'lg:max-h-[100vh-150px] max-h-[440px] !translate-x-[-16px] shadow-[0_10px_20px_0] shadow-dark-950/30 z-50 lg:!fixed lg:!top-[62px] md:!w-[calc(100%-32px)] md:!transform-none md:!left-[16px] md:!right-[16px]',
		notificationListNewNotificationsNotice__button:
			'bg-secondary-500 hover:bg-secondary-300 text-dark-950 font-semibold rounded-xs p-[2px_16px] font-semibold text-[12px] border-[1px] border-transparent border-b-dark-950/20',
		preferences__button: 'hidden',
		notification: 'p-[12px_24px] hover:bg-dark-700 border-b-[1px] border-dark-600',
		notificationBody:
			'text-[14px] relative flex flex-col [&>p]:order-1 [&>p]:text-md [&>p]:leading-[1.4] [&>p]:pr-[30px] [&>.nt-float-right.nt-relative]:order-2 [&>.nt-float-right.nt-relative]:float-none [&>.nt-float-right.nt-relative]:static [&>.nt-float-right.nt-relative]:mt-[8px]',
		notificationCustomActions: 'mt-0',
		button: '',
		notificationPrimaryAction__button: `${actionButton} bg-primary-500 hover:bg-primary-300`,
		notificationSecondaryAction__button: `${actionButton} bg-secondary-500 hover:bg-secondary-300`,
		notificationDefaultActions:
			'absolute top-0 right-0 w-[20px] h-full items-end justify-start bg-transparent backdrop-blur-none',
		notificationDot: 'bg-primary-500 border-none transform-none top-[12px] right-[24px]',
		notificationImage: 'hidden',
		notificationArchive__button: 'hidden',
		tooltipContent: 'bg-dark-600 p-md text-white shadow-[0_5px_20px_0] shadow-dark-950/30',
		moreActions__dropdownTrigger: 'text-white/70 hover:text-white transition-color',
		inboxStatus__dropdownItemRight__icon: 'text-white/70 hover:text-white transition-color',
		moreActions__dropdownContent: `${dropdownContent} -translate-x-[40px]`,
		inboxStatus__dropdownContent: `${dropdownContent} translate-x-[55px]`,
		notificationUnread__button: notificationUnread,
		notificationRead__button: notificationUnread,
		notificationListEmptyNoticeIcon: 'text-white/50',
		notificationListEmptyNotice: 'text-white/50',
		notificationDate: '[all:unset] !text-dark-200 !text-sm !opacity-100',
	},
};

export const popoverArrow =
	'lg:hidden absolute bottom-0 right-[50%] translate-x-[50%] translate-y-[10px] border-b-[10px] border-l-[10px] border-r-[10px] border-b-dark-700 border-l-transparent border-r-transparent opacity-70';
